const config = {
  WORLD_SIZE: 5, //10,
  CHARACTER_MAX_HP: 100,
  CHARACTER_AGE_OLD_START: 60 * 12, //AGE FROM WHICH AGING HAS CONSEQUENCES
  HAVING_SEX_BASE_CHANCE: 0.2,
  PREGNANCY_BASE_CHANCE: 0.2,
  CHARACTER_AGE_ADULT_START: 10 * 12, //SAME FOR MALE/FEMALE
  PREGNANCY_AGE_MAX: 45 * 12, //ONLY FOR FEMALE
  PREGNANCY_DURATION: 9,
  BIRTH_DEATH_CHANCE: 0.05,
  POP_FACTOR: 10, //multiply WORLD_SIZE * WORLD_SIZE * POP_FACTOR to get starting pop number
  FOOD_INCREASE_RATE: 1.1,
  HUNGER_DMG_MOVE_TRIGGER: 0.2, //moving when dmg is X% of maxHP
  PREY_TO_FOOD_RATE: 10,
  PREY_HUNT_CHANCE: 0.09, // 0.15,
  PREY_REPRODUCE_RATE: 0.1, //
  PREY_REPRODUCE_MAX: 50, //Base value to cap max animal prey birth
  PREY_ATTRITION_RATE: 0.98, //natural death/illness/etc...
};
export default config;
